
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 59.744c-9.332 0-10.437-.032-14.1-.205C5.684 59.068.695 54.1.205 43.896.032 40.248 0 39.116 0 29.872 0 20.58.032 19.48.205 15.848.695 5.786 5.826.66 15.9.204 19.658.031 20.779 0 30 0c9.205 0 10.421.047 14.053.204C54.3.66 59.289 5.644 59.795 15.848c.173 3.679.205 4.81.205 14.024 0 9.291-.032 10.392-.205 14.008-.49 10.062-5.637 15.188-15.742 15.643-3.616.19-4.721.22-14.053.22zm0-56.568c-9.142 0-10.247.031-13.942.204-8.48.393-12.284 4.167-12.68 12.64-.173 3.57-.204 4.639-.204 13.867 0 9.166.031 10.283.205 13.867.41 8.49 4.2 12.264 12.695 12.657 3.6.157 4.69.204 13.942.204 9.268 0 10.342-.032 13.91-.205 8.51-.392 12.316-4.166 12.727-12.656.173-3.569.205-4.638.205-13.866 0-9.135-.032-10.251-.205-13.867-.41-8.474-4.216-12.263-12.727-12.64-3.679-.174-4.768-.205-13.926-.205z"}}),_c('path',{attrs:{"d":"M30 45.578c-8.684 0-15.758-7.043-15.758-15.69 0-8.648 7.074-15.691 15.758-15.691s15.758 7.043 15.758 15.69c0 8.648-7.074 15.691-15.758 15.691zm0-28.237c-6.948 0-12.6 5.629-12.6 12.546 0 6.918 5.652 12.547 12.6 12.547 6.947 0 12.6-5.629 12.6-12.546 0-6.918-5.653-12.547-12.6-12.547zM47.479 15.77a3.309 3.309 0 003.316-3.303 3.309 3.309 0 00-3.316-3.301 3.309 3.309 0 00-3.316 3.301 3.309 3.309 0 003.316 3.302z"}})])
          )
        }
      }
    